import clsx from 'clsx';

type IconProps = JSX.IntrinsicElements['svg'] & {
    direction?: 'up' | 'right' | 'down' | 'left';
  };

function Icon({
    children,
    className,
    fill = 'currentColor',
    stroke,
    ...props
}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            {...props}
            fill={fill}
            stroke={stroke}
            className={clsx('', className)}
        >
            {children}
        </svg>
    );
}

export default function RemoveIcon(props: IconProps) {
    return (
        <Icon {...props} fill="transparent" stroke={props.stroke || 'currentColor'}>
            <title>Remove</title>
            <path
                d="M4 6H16"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8.5 9V14" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 9V14" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M5.5 6L6 17H14L14.5 6"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 6L8 5C8 4 8.75 3 10 3C11.25 3 12 4 12 5V6"
                strokeWidth="1.25"
            />
        </Icon>
    );
}